import { render, staticRenderFns } from "./HeaderTab.vue?vue&type=template&id=4bc30fa7&"
import script from "./HeaderTab.vue?vue&type=script&lang=js&"
export * from "./HeaderTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports